'use client';

/**
 * Skeleton loading state for FiltersSidebar.
 * Matches the real sidebar structure: title + 3 filter groups with checkbox rows.
 * Uses solid #F8F8F8 blocks (consistent with ProductCardSkeleton).
 */
export default function FiltersSidebarSkeleton() {
  return (
    <div className="flex flex-col items-start w-[330px] h-full bg-[#F8F8F8] pt-6 pr-9 pb-6 pl-6 gap-6">
      {/* Title placeholder — matches "Φίλτρα" */}
      <div className="w-[60px] h-[14px] bg-[#E8E8E8] rounded-[4px]" />

      {/* Filter groups */}
      <div className="flex flex-col items-start self-stretch gap-0">
        {/* Group 1: 4 items */}
        <FilterGroupSkeleton itemCount={4} />
        {/* Group 2: 5 items */}
        <FilterGroupSkeleton itemCount={5} isMiddle />
        {/* Group 3: 3 items */}
        <FilterGroupSkeleton itemCount={3} isMiddle />
      </div>
    </div>
  );
}

function FilterGroupSkeleton({ itemCount, isMiddle }: { itemCount: number; isMiddle?: boolean }) {
  return (
    <div className={`flex flex-col items-start gap-2 self-stretch pb-4 border-b border-[#D8D8D8]${isMiddle ? ' pt-4' : ''}`}>
      {/* Group title placeholder */}
      <div className="w-[120px] h-[14px] bg-[#E8E8E8] rounded-[4px]" />

      {/* Checkbox rows */}
      <div className="flex flex-col items-start self-stretch">
        {Array.from({ length: itemCount }, (_, i) => (
          <div key={i} className="flex h-8 py-2 items-center self-stretch gap-2">
            {/* Checkbox square */}
            <div className="w-[16px] h-[16px] bg-[#E8E8E8] rounded-[3px] flex-shrink-0" />
            {/* Label bar — varying widths for realism */}
            <div
              className="h-[14px] bg-[#E8E8E8] rounded-[4px]"
              style={{ width: `${70 + ((i * 37) % 60)}px` }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
